// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.my-account-section {
  padding: 0;
  margin: 0;
}
.my-account-section .my-account-content {
  padding: 2%;
  border: 0.1rem solid #fff;
}
.my-account-section form label {
  text-transform: uppercase;
  font-weight: normal;
  text-align: left !important;
}
.my-account-section form .form-title button {
  margin: 0 1rem;
  text-transform: uppercase;
  border: none;
  background: none;
}
.my-account-section form .form-title button:focus {
  outline: none;
}`, "",{"version":3,"sources":["webpack://./src/Components/Pages/Account/MyAccountSection.scss"],"names":[],"mappings":"AAAA;EACE,UAAA;EACA,SAAA;AACF;AAAE;EACE,WAAA;EACA,yBAAA;AAEJ;AACI;EACE,yBAAA;EACA,mBAAA;EACA,2BAAA;AACN;AAEM;EACE,cAAA;EACA,yBAAA;EACA,YAAA;EACA,gBAAA;AAAR;AAEM;EACE,aAAA;AAAR","sourcesContent":[".my-account-section {\n  padding: 0;\n  margin: 0;\n  .my-account-content {\n    padding: 2%;\n    border: 0.1rem solid #fff;\n  }\n  form {\n    label {\n      text-transform: uppercase;\n      font-weight: normal;\n      text-align: left !important;\n    }\n    .form-title {\n      button {\n        margin: 0 1rem;\n        text-transform: uppercase;\n        border: none;\n        background: none;\n      }\n      button:focus {\n        outline: none;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
